import client from './client';

export interface AndroidApkManifest {
  file_name: string;
  original_name: string;
  version_code: number | null;
  version_name: string | null;
  release_notes: string | null;
  force_update: boolean;
  min_supported_version_code: number | null;
  mime_type: string;
  size: number;
  sha256: string;
  download_url: string;
  uploaded_by: string | null;
  uploaded_at: string;
}

export const androidAppApi = {
  getLatestApk: () =>
    client.get<{ success: true; data: AndroidApkManifest }>('/android-app/latest'),
};
